import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fl-seo-faq-item',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqItemComponent {
  @Input() question: string;
  @Input() answer: string;
}
